import type { IndustryContent } from '@/types/content';
import { getTestimonialsByIndustry } from '../testimonials';

export const poolSpaContent: IndustryContent = {
  slug: 'pool-service',
  name: 'Pool & Spa',
  headline: 'The Operating System for Pool Service Companies',
  subheadline:
    'Track chemicals, manage routes, and keep pools crystal clear—all from one platform built for pool professionals.',
  heroImageUrl: '/images/industries/poolspa-hero.webp',
  painPoints: [
    {
      title: 'Chemical tracking is all over the place',
      description:
        'Readings in notebooks, texts to the office, handwritten logs—when something goes wrong, good luck finding the history.',
      icon: 'chemistry',
    },
    {
      title: 'Seasonal demand is feast or famine',
      description:
        'Pool openings and closings slam you all at once. Scheduling 200+ visits in two weeks is overwhelming.',
      icon: 'calendar-x',
    },
    {
      title: 'Routes waste time and fuel',
      description:
        'Techs crisscross neighborhoods hitting pools in the wrong order. Tight margins mean every mile matters.',
      icon: 'route',
    },
    {
      title: 'Equipment service history is missing',
      description:
        'When a pump fails, you don\'t know if it was serviced last month or last year. Warranty claims become guesswork.',
      icon: 'equipment',
    },
  ],
  features: [
    {
      title: 'Digital Chemical Logs',
      description:
        'Record readings on mobile with automatic dosing recommendations. Full history for every pool at your fingertips.',
      icon: 'chemistry',
    },
    {
      title: 'Route Optimization',
      description:
        'Build the most efficient routes automatically. Techs hit more pools per day with less windshield time.',
      icon: 'route',
    },
    {
      title: 'Equipment Tracking',
      description:
        'Track every pump, heater, and filter. Serial numbers, install dates, warranty info, and complete service history.',
      icon: 'equipment',
    },
    {
      title: 'Seasonal Scheduling',
      description:
        'Manage pool openings and closings at scale. Automated scheduling for your busiest weeks of the year.',
      icon: 'seasonal',
    },
    {
      title: 'Service Agreements',
      description:
        'Weekly, bi-weekly, or monthly plans with automated billing. Predictable revenue, happy customers.',
      icon: 'agreement',
    },
    {
      title: 'Before/After Photos',
      description:
        'Document pool condition at every visit. Protect yourself and show customers the value you provide.',
      icon: 'camera',
    },
  ],
  testimonial: getTestimonialsByIndustry('pool-service')[0],
  stats: [
    { label: 'Route Efficiency', value: '+35%' },
    { label: 'Pools Per Tech Per Day', value: '22' },
    { label: 'Chemical Tracking Accuracy', value: '99%' },
    { label: 'Service Agreement Retention', value: '91%' },
  ],
  seo: {
    title: 'Pool Service Software | Route & Chemical Management | Omniforge',
    description:
      'Pool and spa service software built for pros. Route optimization, chemical tracking, equipment history, and automated billing. Start your free trial.',
    keywords: [
      'pool service software',
      'pool route software',
      'pool chemical tracking',
      'pool business software',
      'spa service software',
      'pool maintenance software',
    ],
  },
};
